<template>
  <div
    class="appo"
    @dblclick.prevent
  >
    <div class="appo__header">
      <!-- <base-heading class="mb-0">
        {{ appointment.subject }}
        <base-icon icon="add-link" />
      </base-heading> -->
      <!--eslint-disable-next-line-->
      <template v-if="logo">
        <div class="appo__logo__container">
          <img
            class="appo__logo"
            :src="`${logo}?h=100&fit=clip`"
            alt=""
          >
        </div>
      </template>
    </div>
    <div class="appo__main">
      <div class="appo__container">
        <div class="appo__left">
          <div
            id="local--"
            ref="local"
            class="appo__video"
          >
            <div class="appo__video__container">
              <!-- Acá va el video -->
              <video-main
                :id="mainVideo.sid"
                :video="mainVideo"
                :shared-screen="sharedScreen"
              />
            </div>
            <div class="appo__floating-actions">
              <!-- Button connect for Mobile -->
              <base-button
                v-if="!connected"
                class="appo__connect-button"
                @click="videoconnect"
              >
                Connect
              </base-button>
              <!-- Button dicconnect for Mobile -->
              <base-button
                v-if="connected"
                class="appo__call-button"
                nowrap
                accent
                @click="disconnect"
              >
                End
              </base-button>

              <participant-count
                :connected="connected"
                :appointment="appointment"
                :participants="participants"
                virtual
                small
              />

              <div
                v-if="connected === true"
                class="appo__actions-button"
                @click="showMenuMobile = !showMenuMobile"
              >
                <base-icon icon="ellipsis-h" />
              </div>
              <div
                v-if="showMenuMobile === true"
                class="appo__actions-button-box"
              >
                <template v-for="action in actions">
                  <div
                    v-if="(appointment.is_host && action.hostOnly) || !action.hostOnly"
                    :key="action.icon"
                    class="appo__action"
                    @click="
                      action.action();
                      showMenuMobile = false;
                    "
                  >
                    <!-- <base-tooltip text="none">                     -->
                    <base-icon :icon="(action.active())? action.icon : action.activeIcon" />
                    {{ (action.active())? action.text : action.activeText }}
                  <!-- </base-tooltip> -->
                  </div>
                </template>
              </div>
            </div>
            <div class="appo__chat__small">
              <chat-container
                v-show="chatOpened"
                :is-mobile="true"
                :appointment-id="appointment.pk"
                :username="username"
              />
              <div class="appo__chat__small__icon">
                <chat-notification :number="unreadCount">
                  <base-icon
                    style="position: relative; z-index: 103"
                    :icon="chatOpened ? 'open-chat' : 'no-chat'"
                    @click="openChat"
                  />
                </chat-notification>
              </div>
            </div>
            <div
              class="appo__participants"
              :class="{ 'appo__participants--screen-shared': sharedScreen }"
            >
              <div
                v-show="connected"
                ref="localSmall"
                class="appo__video__local"
              />
              <div
                v-for="(participant, index) in participants"
                :id="participant.sid"
                :key="index"
              >
                <video-participant
                  :visible="participant.sid != mainParticipant.sid"
                  :participant="participant"
                  @host-message="onHostMessage"
                  @track-added="trackAdded"
                />
              </div>
            </div>
            <participant-count
              :connected="connected"
              :appointment="appointment"
              :participants="participants"
              virtual
            />
            <video-product-detail-container
              v-if="connected === true && itemSelected !== null && itemSelected.pk"
              ref="pinned"
              :can-close="appointment.is_host"
              :actions-allowed="appointment.is_host"
              :product-id="itemSelected.pk"
              :offset="itemSelectedCarouselOffset"
              :thumbnail-url="thumbnailUrl"
              @close="closeProduct()"
              @scroll="handleScroll"
            />
            <div
              v-if="false"
              class="appo__pinned-item"
            >
              <div class="appo__pinned-item__container">
                <img
                  class="appo__pinned-item__img"
                  :src="product_url"
                >
                <base-icon
                  v-if="appointment.is_host"
                  icon="cancel"
                  class="appo__pinned-item__button"
                  @click="product_url = ''"
                />
              </div>
            </div>
          </div>
          <div class="appo__controls">
            <template v-if="connected">
              <chat-container
                v-show="chatOpened"
                :appointment-id="appointment.pk"
                :username="username"
              />
              <template v-for="action in actions">
                <span
                  v-if="(appointment.is_host && action.hostOnly) || !action.hostOnly"
                  :key="action.icon"
                  class="appo__action"
                  @click="action.action()"
                >
                  <template v-if="action.icon === 'appointment-link'">
                    <base-tooltip :text="inviteLinkText">
                      <base-icon
                        class="action-icon"
                        :icon="action.active() ? action.icon : action.activeIcon"
                      />
                      {{ action.active() ? action.text : action.activeText }}
                    </base-tooltip>
                  </template>
                  <template v-else>
                    <base-icon
                      class="action-icon"
                      :icon="action.active() ? action.icon : action.activeIcon"
                    />
                    {{ action.active() ? action.text : action.activeText }}
                  </template>
                </span>
              </template>
            </template>

            <div class="ml-auto">
              <base-button
                v-if="!connected"
                @click="videoconnect"
              >
                Connect
              </base-button>
              <base-button
                v-if="connected"
                nowrap
                accent
                @click="disconnect"
              >
                End Appointment
              </base-button>
            </div>
          </div>
        </div>
        <div
          v-if="connected"
          class="appo__right"
          :class="{
            'appo__right--half': showProducts === 1,
            'appo__right--open': showProducts === 2,
          }"
        >
          <div
            class="appo__toggle-products"
            @click="openProducts()"
          >
            {{ showProductsMessages[showProducts] }}
            <base-icon
              class="appo__toggle-products__icon"
              :icon="showProducts === 2 ? 'arrow-down' : 'arrow-up'"
            />
          </div>
          <div
            class="appo__right__scrollable"
            :class="{ 'appo__right__scrollable--horizontal': showProducts === 1 }"
          >
            <video-product
              v-for="(prodImage, index) in productImages"
              :key="index"
              v-multiclick
              :product-image="prodImage"
              :active="itemSelected && itemSelected.pk === prodImage.product.pk"
              :can-like="!appointment.is_host"
              :favorite="likedProducts.includes(prodImage.product.pk)"
              @single-click="selectProduct(prodImage)"
              @like="like(prodImage.product)"
              @unlike="unlike(prodImage.product)"
            />
          </div>
        </div>
      </div>
      <input
        ref="link"
        type="text"
        :value="inviteLink"
        style="opacity: 0"
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { eventsService } from '@/_services';
import ParticipantCount from '../../components/Widgets/Appointments/ParticipantCount';
import VideoParticipant from './VideoParticipant';
import VideoProduct from './VideoProduct';
import VideoMain from './VideoMain';
import VideoProductDetailContainer from './VideoProductDetailContainer';

const Video = require('twilio-video');

const { LocalDataTrack } = Video;
// room.localParticipant.tracks.foreach((a=>any)=>{if(a.kind=="video"){videoelement=a.track}})
const SELF_PREVIEW_ID = 'self_preview';
export default {
  name: 'VideoCall',
  components: {
    ParticipantCount,
    VideoParticipant,
    VideoProduct,
    VideoMain,
    VideoProductDetailContainer,
  },
  props: {
    appointment: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      logo: '',
      room: null,
      itemSelectedCarouselOffset: 0,
      participants: [],
      connected: false,
      muted: false,
      video_active: true,
      screenTrack: null,
      dataTrack: null,
      productImages: [],
      inviteLink: null,
      inviteLinkText: 'Copy link',
      itemSelected: null,
      thumbnailUrl: null,
      showProducts: 0,
      showProductsMessages: ['See products', 'See all products', 'See fewer products'],
      localParticipant: {},
      mainVideo: {},
      mainParticipant: {},
      dominantParticipant: null,
      sharedScreen: false,
      showMenuMobile: false,
      chatOpened: false,
      actions: [
        {
          active: () => this.chatOpened,
          text: 'Close Chat',
          activeText: 'Open Chat',
          icon: 'no-chat',
          activeIcon: 'open-chat',
          action: this.openChat,
          hostOnly: false,
        },
        {
          active: () => this.video_active,
          text: 'Stop Video',
          activeText: 'Start Video',
          icon: 'video-camera',
          activeIcon: 'stop-video',
          action: this.togglevideo,
          hostOnly: false,
        },
        {
          active: () => this.muted,
          text: 'Unmute',
          activeText: 'Mute',
          icon: 'mute',
          activeIcon: 'mic',
          action: this.togglemute,
          hostOnly: false,
        },
        {
          active: () => this.screenTrack === null,
          text: 'Share Screen',
          activeText: 'Stop Sharing',
          icon: 'share-screen',
          activeIcon: 'stop-sharing',
          action: this.toggleShareScreen,
          hostOnly: true,
        },
        {
          active: () => true,
          text: 'Copy Appointment Link',
          activeText: 'Copy Appointment Link',
          icon: 'appointment-link',
          activeIcon: 'appointment-link',
          action: this.copyLink,
          hostOnly: true,
        },
      ],
    };
  },
  computed: {
    lastParticipant() {
      const { length } = this.participants;
      if (length > 0) {
        return this.participants[length - 1];
      }
      return false;
    },
    likedProducts() {
      return this.appointment.likes.map((like) => like.product__pk);
    },
    unreadCount() {
      if (this.$store.state.chat.unreadMessageCount && !this.chatOpened) {
        return this.$store.state.chat.unreadMessageCount;
      } else {
        return 0;
      }
    },
    username() {
      if (this.appointment.anon === null) {
        return `${this.appointment.name}[${this.appointment.invite_pk}]`;
      } else {
        return `${this.appointment.name}[${this.appointment.anon}]`;
      }
    },
  },
  watch: {
    '$store.state.chat.messages': {
      handler() {
        if (this.chatOpened) {
          this.$store.dispatch('chat/setAllMessagesAsRead');
        } else {
          this.$store.dispatch('chat/getUnreadMessagesCount');
        }
      },
    },
    '$store.state.chat.task': {
      handler() {
        this.onHostMessage(this.$store.state.chat.task);
      },
    },
    participants: {
      handler() {
        this.handleUpdateParticipants();
      },
      deep: true,
    },
    mainVideo: {
      handler() {
        console.log('this.mainVideo', this.mainVideo);
      },
      deep: true,
    },
  },
  mounted() {
    // Remove scrolling
    const $body = document.querySelector('body');
    $body.style.overflow = 'hidden';
    // get the toke
    this.addPreview();
    this.status('Video Mounted');
    this.joinChatRoom();
  },
  destroyed() {
    const $body = document.querySelector('body');
    $body.style.removeProperty('overflow');
  },
  methods: {
    status(text) {
      // this.$refs.status.innerHTML = text;
      console.log(text);
    },
    disconnect() {
      this.connected = false;
      const localVideoTrack = this.localVideTrack();
      const videoSmall = this.$refs.localSmall;
      videoSmall.appendChild(localVideoTrack.attach());
      localVideoTrack.detach().forEach((element) => {
        element.remove();
      });
      this.room.disconnect();
      // while (container.lastChild.id !== 'local'){
      //   container.removeChild(container.lastChild);
      // }
      // button.innerHTML = 'Join call';
      // connected = false;
      // updateParticipantCount();
    },
    joinChatRoom() {
      this.$store
        .dispatch('chat/joinChatRoom', {
          appointmentId: this.appointment.pk,
          username: this.username,
        })
        .then(() => {
          console.log('SHOULD PARSE INITIAL SYSTEM');
          // this.parseInitialSystemMessages();
        });
    },
    videoconnect(event) {
      this.stopPreview();
      this.status('Connecting ...');
      Video.connect(this.appointment.token, {
        name: this.appointment.room_id,
        dominantSpeaker: true,
      })
        .then((room) => {
          this.room = room;
          this.addLocalVideo();
          console.log('room', room);
          this.status(`Connected to Room ${room.name}`);
          this.connected = true;
          room.participants.forEach((participant) => {
            console.log('Initials participans', participant);
            this.participantConnected(participant);
          });
          room.on('participantConnected', (participant) => {
            console.log('participantConnected', participant);
            this.participantConnected(participant);
          });
          room.on('participantDisconnected', (participant) => {
            console.log('participant DisConnected', participant);
            this.participantDisconnected(participant);
          });
          room.on('trackPublished', (track, participant) => {
            console.log('trackAdded', track.trackName);
            console.log('trackAdded', track);
          });
          room.on('trackRemoved', (track, participant) => {
            console.log('Removed');
          });
          room.on('trackUnsubscribed', (track, participant) => {
            console.log('trackUnsubscribed');
            this.handleUpdateParticipants();
          });
          room.on('dominantSpeakerChanged', (participant) => {
            console.log('The new dominant speaker in the Room is:', participant);
            this.dominantParticipant = participant;
            this.handleUpdateParticipants();
          });
          room.once('disconnected', (innerroom, error) => this.onDisconnect(innerroom, error));
        }).then(() => {
          this.connectDataTrack();
        })
        .then(() => axios.get(`${this.apiRoot()}${this.appointment.detail}video_data/`))
        .then((r) => {
          this.productImages = r.data.product_images;
          this.logo = r.data.institution.logo;
          this.inviteLink = r.data.invite_link;
        });
    },
    connectDataTrack() {
      // const tracks = []
      // if (this.appointment.is_host) {
      // Only the owner can post into the data track
      this.dataTrack = new LocalDataTrack();
      this.room.localParticipant.publishTrack(this.dataTrack);
    },
    toggleShareScreen() {
      if (this.screenTrack == null) {
        navigator.mediaDevices
          .getDisplayMedia()
          .then((stream) => {
            this.screenTrack = new Video.LocalVideoTrack(stream.getTracks()[0], { name: 'screen' });
            this.room.localParticipant.publishTrack(this.screenTrack);
          })
          .catch((error) => {
            this.status(`Could not share screen ${error.message}`);
          });
      } else {
        this.room.localParticipant.unpublishTrack(this.screenTrack);
        this.screenTrack.stop();
        this.screenTrack = null;
      }
    },
    onDisconnect(room, error) {
      if (error) {
        this.status(`Disconected Error ${error.message}`);
      }
      this.connected = false;
      this.product_url = null;
      this.room.participants.forEach((participant) => this.participantDisconnected(participant));
      this.room.disconnect();
    },
    togglemute() {
      console.log('Toggle!');
      const value = this.muted;
      console.log('Toggle!', value);
      console.log('Toggle!', this.room.localParticipant.audioTracks);
      this.room.localParticipant.audioTracks.forEach((track) => {
        if (value) {
          track.track.enable();
        } else {
          track.track.disable();
        }
      });
      this.muted = !this.muted;
    },
    like(prod) {
      axios
        .post(`${this.apiRoot()}/productlike/`, {
          product: prod.pk,
          appointment: this.appointment.pk,
          _customer: this.appointment.invite_pk,
          _anonymous_participant: this.appointment.anon,
        })
        .then((r) => {
          this.appointment.likes.push({ product__pk: prod.pk, pk: r.data.pk });
          prod.like = r.data.pk;
        });
      this.sendMessage({
        action: 'likeProduct',
        payload: {
          product: prod,
        },
      });
    },
    unlike(prod) {
      const likePk = this.appointment.likes.find((item) => item.product__pk === prod.pk).pk;
      axios
        .delete(`${this.apiRoot()}/productlike/${likePk}/`)
        .then(() => {
          this.appointment.likes = this.appointment.likes.filter((item) => item.pk !== likePk);
        })
        .catch(() => {
          console.error('Failed to unlike', likePk);
        });
      this.sendMessage({
        action: 'unlikeProduct',
        payload: {
          product: prod,
        },
      });
    },
    closeProduct() {
      this.itemSelected = null;
      this.thumbnailUrl = null;
      this.sendMessage({
        action: 'deselectProduct',
      });
    },
    handleScroll(direction) {
      this.sendMessage({
        action: 'scrollProduct',
        payload: { direction },
      });
    },
    selectProduct(prodImage) {
      const prod = prodImage.product;
      if (!this.appointment.is_host) {
        this.openInNewTab(prod.site_url);
        eventsService.saveClickEvent({ ...prod, inv_uuid: this.$route.params.id });
        return;
      }
      this.showProducts = 1;
      if (this.itemSelected && this.itemSelected.pk === prod.pk) {
        this.itemSelected = null;
        this.sendMessage({
          action: 'deselectProduct',
        });
      } else {
        this.itemSelected = prod;
        this.thumbnailUrl = prodImage.image_url;
        this.sendMessage({
          action: 'selectProduct',
          payload: { item: prod, thumbnailUrl: prodImage.image_url },
        });
      }
    },
    togglevideo() {
      const value = this.video_active;
      this.room.localParticipant.videoTracks.forEach((track) => {
        if (value) {
          track.track.disable();
        } else {
          track.track.enable();
        }
      });
      this.video_active = !this.video_active;
    },
    openChat() {
      this.chatOpened = !this.chatOpened;
      if (this.chatOpened) {
        this.$store.dispatch('chat/setAllMessagesAsRead');
      }
    },
    copyLink() {
      const copyText = this.$refs.link;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand('copy');
      this.inviteLinkText = 'Copied!';
      setTimeout(() => {
        this.inviteLinkText = 'Copy link';
      }, 5000);
    },
    localVideTrack() {
      if (this.room) return Array.from(this.room.localParticipant.videoTracks.values())[0].track;
      return this.localParticipant;
    },
    addPreview() {
      const constrains = {
        audio: true,
        video: { width: '100%' },
      };
      Video.createLocalVideoTrack(constrains).then((track) => {
        // const video = this.$refs.local.firstChild;
        const videoSmall = this.$refs.localSmall;
        // We need to ignore the data track
        if (track.kind !== 'data') {
          this.mainVideo = track;
          this.localParticipant = track;
          // video.appendChild(track.attach());
          const att = track.attach();
          att.setAttribute('id', SELF_PREVIEW_ID);
          videoSmall.appendChild(att);
        }
      });
    },
    stopPreview() {
      const elem = document.getElementById(SELF_PREVIEW_ID);
      console.log('elem', elem);
      if (elem) {
        elem.parentElement.removeChild(elem);
      }
      if (this.localParticipant.stop) {
        this.localParticipant.stop();
      }
      this.localParticipant = {};
      this.itemSelected = null; // Resets selected item
    },
    addLocalVideo() {
      console.log('Add Local Video');
      // this.room.localParticipant.tracks.foreach((a=>any)=>{if(a.kind=="video"){videoelement=a.track}})
      const localVideoTrack = this.localVideTrack();
      const videoSmall = this.$refs.localSmall;
      videoSmall.appendChild(localVideoTrack.attach());
      /*
      Video.createLocalVideoTrack(constrains).then((track) => {
        // const video = this.$refs.local.firstChild;
        const videoSmall = this.$refs.localSmall;
        // We need to ignore the data track
        if (track.kind !== 'data') {
          this.mainVideo = track;
          this.localParticipant = track;
          // video.appendChild(track.attach());
          videoSmall.appendChild(track.attach());
        }
      });
      */
    },
    participantConnected(participant) {
      this.status(`Participant "${participant.identity}`);
      this.participants.push(participant);
    },
    sendMessage(message) {
      console.log('Send message', message);
      this.dataTrack.send(JSON.stringify(message));
    },
    onHostMessage(message) {
      this.status(message);
      const { action, payload } = JSON.parse(message);
      console.log('onHostMessage', message);
      if (action === 'selectProduct') {
        this.itemSelectedCarouselOffset = payload.offset;
        this.product_url = payload.url;
        this.itemSelected = payload.item;
        this.thumbnailUrl = payload.thumbnailUrl;
      }
      if (action === 'deselectProduct') {
        this.itemSelected = null;
        this.thumbnailUrl = null;
      }
      if (action === 'likeProduct') {
        console.log('Like');
      }
      if (action === 'scrollProduct') {
        const { pinned } = this.$refs;
        pinned.$refs.product.scroll(payload.direction);
      }
    },
    participantDisconnected(participant) {
      this.status(`Participant ${participant.identity} disconnected`);
      const index = this.participants.indexOf(participant);
      if (index >= 0) {
        this.participants.splice(index, 1);
      }
      this.handleUpdateParticipants();
    },
    trackAdded(evt) {
      if (evt.name === 'screen') {
        this.sharedScreen = true;
      } else {
        this.sharedScreen = false;
      }
      this.handleUpdateParticipants();
    },
    handleUpdateParticipants() {
      const { length } = this.participants;
      if (length > 0) {
        const lastParticipant = this.dominantParticipant || this.participants[length - 1];
        lastParticipant.tracks.forEach((track) => {
          if (track.kind === 'video') {
            if (track.track) {
              this.mainVideo = track.track;
              this.mainParticipant = lastParticipant;
            }
          }
        });
      } else {
        this.mainVideo = this.localParticipant;
      }
    },
    openProducts() {
      this.showProducts = this.showProducts + 1;
      if (this.showProducts > 2) {
        this.showProducts = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$breakpoint-1: 1024px;
.appo {
  // margin-top: -60px;
  padding-top: 50px;
  background: $black;
  // padding-bottom: 1rem;
  // min-height: 100vh;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  @media (min-width: $breakpoint-1) {
    padding-top: 60px;
  }
  &__header {
    display: flex;
    width: 100%;
    min-height: 70px;
    background: white;
    padding: 0.5rem 1rem;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9999;
    box-shadow: 0 0 20px rgba(black, 0.1);
  }
  &__logo {
    // width: 180px;
    height: 50px;
    object-fit: cover;
    margin: 0 auto;
  }
  // With this we are centering the logo and aligning it to the video
  // @see https://helloseer.slack.com/archives/C015UMFDKRS/p1637561066012600
  &__logo__container{
    width: 100%;
    display: flex;
    justify-items: center;
    @media (min-width: map-get($breakpoints,'lg')) {
      margin-right: calc(250px + 1rem); // Right column width + padding
    }
  }
  &__main {
    top: 75px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    position: absolute;
  }
  &__container {
    min-height: calc(100vh - 100px);
    margin: 0 1rem;
    display: flex;
    @media (min-width: $breakpoint-1) {
      border-radius: 5px;
      background: white;
      // min-height: calc(100vh - 150px);
    }
  }
  &__left {
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    @media (min-width: $breakpoint-1) {
      padding: 1rem;
    }
  }
  &__right {
    background-color: white;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -20px;
    max-height: 40px;
    top: calc(100% - 20px);
    // bottom: 0;
    z-index: 101;
    transition: all 0.2s ease-out;
    box-shadow: 0 0 40px rgba(black, 0.2);
    &--half {
      top: calc(100% - 290px);
      max-height: 100vh;
    }
    &--open {
      top: 30px;
      max-height: 100vh;
      @media (min-width: $breakpoint-1) {
        top: 0;
      }
    }
    @media (min-width: $breakpoint-1) {
      background-color: transparent;
      width: 250px;
      bottom: 0;
      position: relative;
      max-height: inherit;
      box-shadow: none;
    }
  }
  &__right__scrollable {
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 1rem;
    bottom: 0;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    &--horizontal {
      flex-wrap: nowrap;
      & > * {
        margin-right: 1rem;
      }
      @media (min-width: $breakpoint-1) {
        // flex-direction: column;
        flex-wrap: wrap;
        & > * {
          margin-right: 0;
        }
      }
    }
    @media (min-width: $breakpoint-1) {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      padding-top: 14px;
    }
  }
  &__toggle-products {
    background-color: white;
    border-radius: 5px 5px 0 0;
    top: -30px;
    width: 180px;
    height: 30px;
    position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.5rem;
    cursor: pointer;
    &__icon {
      margin-left: 10px;
    }
    @media (min-width: $breakpoint-1) {
      display: none;
    }
  }
  &__chat__small {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 1rem;
    min-height: 48px;
    background: rgba(#d4d4d4, 0.7);
    z-index: 101;
    @media (min-width: $breakpoint-1) {
      display: none;
    }
    &::v-deep .chat {
      bottom: 60px;
    }

    &__icon {
      position: absolute;
      left: 1rem;
      bottom: 1rem;
      width: calc(50% - 120px);
      text-align: center;
    }
  }
  &__video {
    // background: gray;
    line-height: 0;
    height: 100%;
    display: flex;
    position: relative;
  }
  &__video__container {
    height: 99%;
    display: flex;
    width: 100%;
    background-color: $black;
  }
  &__participants {
    position: absolute;
    left: 0rem;
    top: 1rem;
    display: none;
    @media (min-width: 420px) {
      display: flex;
    }
    @media (min-width: $breakpoint-1) {
      left: inherit;
      top: inherit;
      right: 1rem;
      bottom: 1rem;
    }
    &::v-deep video {
      width: 110px !important;
      height: 230px;
      border-radius: 15px;
      overflow: hidden;
      margin-left: 1rem;
      object-fit: cover;
      @media (min-width: $breakpoint-1) {
        width: 240px !important;
        height: 160px;
      }
    }
    &--screen-shared {
      flex-flow: column;
      &::v-deep video {
        width: 180px !important;
        height: 108px;
        border-radius: 0;
      }
    }
  }
  &__video__local ::v-deep video {
    transform: scaleX(-1);
  }
  &__floating-actions {
    right: 1rem;
    left: 1rem;
    top: 1rem;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    @media (min-width: $breakpoint-1) {
      display: none;
    }
  }
  &__call-button {
    padding: 5px 15px;
    background: rgba($clementine, 0.7) !important;
  }
  &__connect-button {
    border: none;
    height: 32px;
    background-color: rgba(#f5efeb, 0.7) !important;
    margin: 0 auto;
  }
  &__actions-button {
    background-color: rgba(#f5efeb, 0.7);
    border-radius: 5px;
    height: 32px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &__actions-button-box {
    background-color: white;
    border-radius: 5px;
    position: absolute;
    right: 0;
    top: 2.5rem;
    padding: 0.5rem;
  }
  &__controls {
    margin-top: 1rem;
    height: 50px;
    display: none;
    align-items: center;
    justify-content: center;
    @media (min-width: $breakpoint-1) {
      display: flex;
    }
  }
  &__action {
    font-size: 0.6rem;
    padding: 0.5rem;
    font-family: $font-family-sans-serif-light;
    display: flex;
    margin: 0 0.5rem;
    align-items: center;
    line-height: 1.1;
    min-width: 50px;
    white-space: nowrap;
    cursor: pointer;
    @media (min-width: 1200px) {
      min-width: 100px;
      font-size: 0.875rem;
    }
    & > * {
      margin-right: 0.5rem;
    }
  }
}
.action-icon {
  max-width: 20px;
  @media (min-width: 1200px) {
    max-width: 24px;
  }
}
</style>
